var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('map-base',{ref:"mapCom",attrs:{"map":_vm.map}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }